import React, { useRef } from 'react';

import { useEntity } from '~/hooks/use-entities';
import { EarningsInsightHeader } from '~/views/earnings-insight-drawer/earnings-insight-widget/components/earnings-insight-header/EarningsInsightHeader';
import { useEarningsInsightDrawer } from '~/views/earnings-insight-drawer/useEarningsInsightDrawer';

import { EarningsInsightTypePill } from '../components/earnings-insight-type-pill/EarningsInsightTypePill';
import { Sidebar } from '../components/side-bar/Sidebar';
import * as S from './EarningsPreview.styles';

export const EarningsPreview = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { activeEntityTag } = useEarningsInsightDrawer();

  // TODO: Add error state handling here
  const { data: entityData } = useEntity(activeEntityTag ?? ''); // TODO: Make this dynamic based on actual entity tag

  return (
    <>
      <S.Wrapper>
        {/* TODO: hardcoded pill data */}
        <EarningsInsightTypePill
          insightType="preview"
          iconName="Alfred"
          publishedDate={new Date('2025-08-27T17:30:00')}
          updatedTime={new Date('2025-08-27T11:47:00')}
          periods="Q4 2025"
          releasedDate={new Date('2025-08-27T16:05:00')}
          isDrawer
        />
        <S.Separator>
          <S.LeftContainer>
            {entityData?.data && (
              <EarningsInsightHeader entity={entityData.data} />
            )}
            <S.Title>
              Snowflake delivers strong growth amid margin pressure and macro
              headwinds
            </S.Title>
            <S.ScrollableContainer ref={containerRef}>
              {'CONTENT'}
            </S.ScrollableContainer>
          </S.LeftContainer>
          <Sidebar entityData={entityData?.data} containerRef={containerRef} />
        </S.Separator>
      </S.Wrapper>
    </>
  );
};
